import AmlHashForm from "aml-hash-form";
import { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
// includes
import StatusBar from "elements/statusBar";
import { api, common, types } from "helpers";

function Form() {
  // props
  const { id } = useParams();
  const navigate = useNavigate();
  // state
  const [status, setStatus] = useState(id ? "process" : "success");
  const [loading, setLoading] = useState(null);
  // validate
  const formFields = {
    name: { validate: ["req"] },
    isActive: { value: types.status[0] },
  };
  const {
    fields,
    errors,
    setValue,
    handleChange,
    handleSubmit,
    setMultiValue,
  } = AmlHashForm(formFields);

  // effect
  useEffect(() => {
    if (id) {
      getInfo();
    }
  }, []);

  const getInfo = () => {
    let data = {
      url: "jobSkill",
      method: "GET",
      query: `/${id}`,
    };
    api.call(data, (res) => {
      if (res.status === 200) {
        let result = res.data;
        let status = types.status.filter((item) => {
          return item.value === result.isActive;
        });
        setMultiValue({
          name: result.name,
          isActive: status[0],
        });
        setStatus("success");
      } else {
        setStatus("error");
      }
    });
  };

  const onSubmit = () => {
    let valid = handleSubmit();
    if (valid) {
      setLoading(true);
      let data = {};
      let params = {
        name: fields.name,
        isActive: fields.isActive.value,
      };
      if (id) {
        data = {
          url: "jobSkill",
          method: "PUT",
          query: `/${id}`,
          body: { ...params },
        };
      } else {
        data = {
          url: "jobSkill",
          method: "POST",
          body: { ...params },
        };
      }
      api.call(data, (res) => {
        if (res.status === 200) {
          common.notify(
            "S",
            `Job Skill has been ${!id ? "created" : "updated"} successfully`
          );
          navigate("/jobskill");
        } else if (res.data.error) {
          common.notify("E", res.data.error);
        } else {
          common.notify("E", "Something went wrong");
        }
        setLoading(false);
      });
    }
  };

  // render
  return (
    <Fragment>
      <div className="title-wrap d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <img
            src={common.loadImg("back-icn.svg")}
            className="ed-cp"
            alt=""
            onClick={() => navigate("/category")}
          />
          <h1 className="page-title ps-4">
            {id ? "Edit" : "Add New"} SKill
          </h1>
        </div>
      </div>
      <div className="content-wrap">
        {status !== "success" ? (
          <StatusBar status={status} />
        ) : (
          <div className="container-fluid">
            <h2 className="form-title">Job Skill</h2>
            <div className="form-wrap">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <label>Skill Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Skill Name"
                    className="form-control"
                    value={fields.name}
                    onChange={handleChange}
                  />
                  <p className="error-txt">{errors.name}</p>
                </div>

                <div className="col-md-6 mb-4">
                  <label>Status</label>
                  <Select
                    className="custom-select-box"
                    value={fields.isActive}
                    options={types.status}
                    isClearable={false}
                    onChange={(data) => {
                      setMultiValue({ isActive: data });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn ed-btn-default ed-btn-save-dt"
                onClick={onSubmit}
                disabled={loading}
              >
                {loading ? "Processing..." : "Save & Update"}
              </button>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
}
export default Form;
